import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

export default function QRCodeGenerator() {
  const [url, setUrl] = useState('');

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>KAAFI PAY</h1>

        <p style={styles.desc}>Enter a URL below to generate a QR Code</p>

        <input
          type="text"
          placeholder="https://example.com/check-balance"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          style={styles.input}
        />

        {url && (
          <div style={styles.qrBox}>
            <QRCodeCanvas
              value={url}
              size={220}
              level="H"
              includeMargin={true}
            />
          </div>
        )}

        <p style={styles.powered}>
          Powered by <b>Kaafiye Tech</b>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f4f6f8',
    fontFamily: 'Arial, sans-serif',
  },
  card: {
    background: '#fff',
    padding: '30px 25px',
    borderRadius: '12px',
    width: '360px',
    textAlign: 'center',
    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
  },
  title: {
    color: '#0a7cff',
    marginBottom: '10px',
  },
  desc: {
    fontSize: '14px',
    color: '#555',
    marginBottom: '20px',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    marginBottom: '20px',
  },
  qrBox: {
    padding: '15px',
    border: '2px dashed #0a7cff',
    borderRadius: '10px',
    marginBottom: '20px',
  },
  powered: {
    fontSize: '13px',
    color: '#777',
  },
};
